import React from 'react';
import { Container, Image } from './styles.js'
import { observer } from 'mobx-react';
import Typography from '@material-ui/core/Typography';

function MobilityItem(props) {

    const { item, theme } = props

    return (
        <Container onClick={() => props.clicked(item)}>
            <Image src={item.Image} alt={item.id} />
            <Typography variant="caption" color="textPrimary" style={{ color: theme.Title }}>{item.id}</Typography>
        </Container>
    )
}

export default observer(MobilityItem);
